module.exports = __webpack_public_path__ + "img/conteudo-indiposnivel-universidade-1.52866349.png";